// extracted by mini-css-extract-plugin
export default {"navigator":"style_navigator__EGw-d","x":"style_x__FThQg"};